<script>
  import { Link } from "../rout"
  import { _, time, date} from 'svelte-i18n'

  export let shop
  export let webpage
  export let blog
</script>
<div class="flex flex-col mx-2 sm:mx-2">
  <div class="meta-buttons mt-1 mb-3 flex flex-row gap-2">
    {#if blog}
      <Link to="{webpage.slug}" class="btn">{$_('back')}</Link>
    {/if}
    <div class="grow flex justify-center self-center font-bold rounded bg-gray-100 dark:bg-black leading-8">{webpage.title}</div>
  </div>

  {#if blog}
    <div class="blog">
      <h1 class="text-lg font-bold underline"><Link to="{webpage.slug}/{blog.slug}">{blog.title}</Link></h1>
      <div class="blog-info flex flex-row gap-2 text-xs">
        <div class="blog-author">Authored by {blog.author}</div>
        <div class="blog-timestamp">{$time(new Date(blog.updated_at))} {$date(new Date(blog.updated_at))}</div>
      </div>
      <div class="mt-3">
        {@html blog.content || ''}
      </div>
    </div>
  {:else}
    <div class="p-4">
      {@html webpage.content || ''}
    </div>
    {#if webpage.blogs}
      <div class="blogs p-4 flex flex-col gap-4">
        {#each webpage.blogs as item}
          <div class="blog">
            <h1 class="text-lg font-bold underline"><Link to="{webpage.slug}/{item.slug}">{item.title}</Link></h1>
            <div class="blog-info flex flex-row gap-2 text-xs">
              <div class="blog-author">Authored by {item.author}</div>
              <div class="blog-timestamp">{$time(new Date(item.updated_at))} {$date(new Date(item.updated_at))}</div>
            </div>
            <div>
              {@html item.summary || ''}
            </div>
            <div class="flex flex-row justify-center items-center">
              <div class="mt-3 btn"><Link to="{webpage.slug}/{item.slug}">Read the full story...</Link></div>
            </div>
          </div>
        {/each}
      </div>
    {/if}
  {/if}
</div>